"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _DragSpin = _interopRequireDefault(require("../../Icons/DragSpin"));
var _getScript = require("../../utils/getScript");
var _helpers = require("../utils/helpers");
var Styled = _interopRequireWildcard(require("../VisualizerLiquidPixel.styles"));
var _useDebounce = _interopRequireDefault(require("../../hooks/useDebounce"));
var _usePolling = _interopRequireDefault(require("../../hooks/usePolling"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } /* eslint-disable max-lines */
var Vizualizer = function Vizualizer(_ref) {
  var lpActive = _ref.lpActive,
    isMobile = _ref.isMobile,
    lpClassName = _ref.lpClassName,
    surroundLibrary = _ref.surroundLibrary,
    textureLoadedUpdatePath = _ref.textureLoadedUpdatePath,
    onError = _ref.onError,
    onLiquidPixelVisualizerLoadedSuccessfully = _ref.onLiquidPixelVisualizerLoadedSuccessfully,
    dragMessage = _ref.dragMessage,
    showDragIcon = _ref.showDragIcon,
    autoRotate = _ref.autoRotate,
    displayDragMessage = _ref.displayDragMessage,
    visualizerChoices = _ref.visualizerChoices,
    visIsReady = _ref.visIsReady,
    setVisIsReady = _ref.setVisIsReady,
    activeTab = _ref.activeTab;
  if (!lpActive || !(visualizerChoices !== null && visualizerChoices !== void 0 && visualizerChoices.activeTexture)) {
    return null;
  }
  var queryParams = new URLSearchParams(window.location.search);
  var debug = queryParams.get('debug-lp');
  var visualizerRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    surroundLibIsLoaded = _useState2[0],
    setSurroundLibIsLoaded = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    surroundLibIsLoading = _useState4[0],
    setSurroundLibIsLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    prevVisualizerChoices = _useState6[0],
    setPrevVisualizerChoices = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    prevActiveTab = _useState8[0],
    setPrevActiveTab = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    viewer = _useState10[0],
    setViewer = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    displayDragIconMessage = _useState12[0],
    setDisplayDragIconMessage = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    displayedDragIconMessage = _useState14[0],
    setDisplayedDragIconMessage = _useState14[1];
  var _useState15 = (0, _react.useState)(null),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    isViewerPolling = _useState16[0],
    setIsViewerPolling = _useState16[1];
  var visualizerChoicesDebounce = (0, _useDebounce["default"])(visualizerChoices, 300);
  var activeTabDebounce = (0, _useDebounce["default"])(activeTab, 300);
  var getViewerStatus = function getViewerStatus() {
    return viewer && viewer.isReady() || false;
  };
  var getVisualizerChoicesAreEqual = function getVisualizerChoicesAreEqual(choices) {
    return (0, _isEqual["default"])(choices, prevVisualizerChoices);
  };
  var updateVisualizerValues = function updateVisualizerValues(choices, prevChoices) {
    // seperate different data sections
    var texture = choices === null || choices === void 0 ? void 0 : choices.activeTexture;
    var texturePrev = prevChoices === null || prevChoices === void 0 ? void 0 : prevChoices.activeTexture;
    var color = choices === null || choices === void 0 ? void 0 : choices.activeColor;
    var colorPrev = prevChoices === null || prevChoices === void 0 ? void 0 : prevChoices.activeColor;
    var logo = choices === null || choices === void 0 ? void 0 : choices.activeLogoGroup;
    var logoPrev = prevChoices === null || prevChoices === void 0 ? void 0 : prevChoices.activeLogoGroup;
    if (!(0, _isEqual["default"])(texture, texturePrev) && viewer.isReady()) {
      viewer.reset({
        model: texture === null || texture === void 0 ? void 0 : texture.model,
        textureMap: (0, _helpers.getTextureMap)(texture, logoPrev, colorPrev)
      });
      setPrevVisualizerChoices(_objectSpread(_objectSpread({}, visualizerChoicesDebounce), {}, {
        activeTexture: _objectSpread({}, texture)
      }));
    }
    if (!(0, _isEqual["default"])(color, colorPrev) && viewer.isReady()) {
      viewer.updateTextureMap((0, _helpers.getTextureMap)(texturePrev, logoPrev, color));
      setPrevVisualizerChoices(_objectSpread(_objectSpread({}, visualizerChoicesDebounce), {}, {
        activeColor: color
      }));
    }
    if (!(0, _isEqual["default"])(logo, logoPrev) && viewer.isReady()) {
      var _logo$activeTabDeboun;
      if (logo !== null && logo !== void 0 && (_logo$activeTabDeboun = logo[activeTabDebounce.toLowerCase()]) !== null && _logo$activeTabDeboun !== void 0 && _logo$activeTabDeboun.url) {
        var rotateProperties = (0, _helpers.getRotateTo)(activeTabDebounce);
        (0, _helpers.updateRotate)(viewer, rotateProperties);
      }
      viewer.updateTextureMap((0, _helpers.getTextureMap)(texturePrev, logo, colorPrev));
      setPrevVisualizerChoices(_objectSpread(_objectSpread({}, visualizerChoicesDebounce), {}, {
        activeLogoGroup: logo
      }));
    }
  };
  var viewerResetFromPolling = function viewerResetFromPolling() {
    var viewerSavedChoicesEqual = (0, _helpers.isSetViewerEqualStageViewer)(viewer, visualizerChoices);
    if (!(viewerSavedChoicesEqual !== null && viewerSavedChoicesEqual !== void 0 && viewerSavedChoicesEqual.value)) {
      viewer.reset(viewerSavedChoicesEqual === null || viewerSavedChoicesEqual === void 0 ? void 0 : viewerSavedChoicesEqual.stateViewerOptions);
      setPrevVisualizerChoices(visualizerChoices);
    }
  };
  (0, _react.useEffect)(function () {
    if (!getVisualizerChoicesAreEqual(visualizerChoicesDebounce)) {
      // check visualizer is active
      var viewerIsActive = getViewerStatus();
      if (viewerIsActive) {
        updateVisualizerValues(visualizerChoicesDebounce, prevVisualizerChoices);
      } else {
        setIsViewerPolling(true);
      }
    } else {
      setIsViewerPolling(true);
    }
  }, [visualizerChoicesDebounce]);
  (0, _usePolling["default"])(function () {
    var viewerIsActive = getViewerStatus();
    if (viewerIsActive) {
      setIsViewerPolling(false);
      viewerResetFromPolling();
    }
  }, isViewerPolling ? 500 : null);
  (0, _react.useEffect)(function () {
    return function () {
      var _window, _window$com, _window$com$liquidpix;
      if ((_window = window) !== null && _window !== void 0 && (_window$com = _window.com) !== null && _window$com !== void 0 && (_window$com$liquidpix = _window$com.liquidpixels) !== null && _window$com$liquidpix !== void 0 && _window$com$liquidpix.Surround) {
        setViewer(null);
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (!surroundLibIsLoaded && !surroundLibIsLoading && window) {
      var _window2, _window2$com, _window2$com$liquidpi, _window4, _window4$com, _window4$com$liquidpi;
      setSurroundLibIsLoading(true);
      if (!((_window2 = window) !== null && _window2 !== void 0 && (_window2$com = _window2.com) !== null && _window2$com !== void 0 && (_window2$com$liquidpi = _window2$com.liquidpixels) !== null && _window2$com$liquidpi !== void 0 && _window2$com$liquidpi.Surround)) {
        (0, _getScript.getScript)(surroundLibrary).then(function () {
          var _window3, _window3$com, _window3$com$liquidpi;
          if ((_window3 = window) !== null && _window3 !== void 0 && (_window3$com = _window3.com) !== null && _window3$com !== void 0 && (_window3$com$liquidpi = _window3$com.liquidpixels) !== null && _window3$com$liquidpi !== void 0 && _window3$com$liquidpi.Surround) {
            setSurroundLibIsLoaded(true);
          }
        })["catch"](function (e) {
          !!onError && onError(e);
        });
      } else if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$com = _window4.com) !== null && _window4$com !== void 0 && (_window4$com$liquidpi = _window4$com.liquidpixels) !== null && _window4$com$liquidpi !== void 0 && _window4$com$liquidpi.Surround) {
        setSurroundLibIsLoaded(true);
      }
    }
  });
  (0, _react.useEffect)(function () {
    if (surroundLibIsLoaded && visualizerRef !== null && visualizerRef !== void 0 && visualizerRef.current && visualizerChoices !== null && visualizerChoices !== void 0 && visualizerChoices.activeTexture && !viewer) {
      var _visualizerChoices$ac;
      setPrevVisualizerChoices(visualizerChoices);
      setPrevActiveTab(activeTab);
      var _window5 = window,
        com = _window5.com;
      setViewer(new com.liquidpixels.Surround((visualizerRef === null || visualizerRef === void 0 ? void 0 : visualizerRef.current) || ".".concat(lpClassName), {
        server: 'homedepot.liquifire.com',
        uri: 'homedepot',
        model: visualizerChoices === null || visualizerChoices === void 0 ? void 0 : (_visualizerChoices$ac = visualizerChoices.activeTexture) === null || _visualizerChoices$ac === void 0 ? void 0 : _visualizerChoices$ac.model,
        textureMap: (0, _helpers.getTextureMap)(visualizerChoices === null || visualizerChoices === void 0 ? void 0 : visualizerChoices.activeTexture, visualizerChoices === null || visualizerChoices === void 0 ? void 0 : visualizerChoices.activeLogoGroup, visualizerChoices === null || visualizerChoices === void 0 ? void 0 : visualizerChoices.activeColor),
        advancedOptions: {
          shadows: {
            enabled: false
          },
          controls: {
            initialPolarAngle: 93,
            maxDollyDistanceFactor: 1.7,
            minDollyDistanceFactor: 0.4
          }
        },
        autoRotate: autoRotate,
        debug: debug || false,
        lighting: [{
          type: 'point',
          color: '#ffffff',
          intensity: 1,
          distance: 0,
          decay: 1,
          castShadow: true,
          position: {
            x: 0,
            y: 0,
            z: 0
          }
        }],
        renderer: {
          hidpi: true
        },
        handleEvent: function handleEvent(eventName, data) {
          if (eventName === 'ready') {
            setTimeout(function () {
              textureLoadedUpdatePath();
            }, '2000');
            onLiquidPixelVisualizerLoadedSuccessfully && onLiquidPixelVisualizerLoadedSuccessfully();
            if (!displayDragIconMessage) {
              setDisplayDragIconMessage(true);
            }
          }
          if (eventName === 'error') {
            !!onError && onError(data);
          }
        }
      }));
    }
  }, [surroundLibIsLoaded, visualizerChoices, visualizerRef]);
  (0, _react.useEffect)(function () {
    if (displayDragIconMessage && !displayedDragIconMessage) {
      setTimeout(function () {
        setDisplayedDragIconMessage(true);
        setTimeout(function () {
          setVisIsReady(true);
        }, 1000);
      }, 3000);
    }
  }, [displayDragIconMessage]);
  (0, _react.useEffect)(function () {
    if (viewer && activeTabDebounce !== prevActiveTab) {
      setPrevActiveTab(activeTabDebounce);
      var rotateProperties = (0, _helpers.getRotateTo)(activeTabDebounce);
      (0, _helpers.updateRotate)(viewer, rotateProperties);
    }
  }, [activeTabDebounce]);
  return /*#__PURE__*/_react["default"].createElement(Styled.VizualizerContainer, null, /*#__PURE__*/_react["default"].createElement(Styled.SurroundMessage, null, /*#__PURE__*/_react["default"].createElement(Styled.DragSpinContainer, null, displayDragIconMessage && showDragIcon && !visIsReady ? /*#__PURE__*/_react["default"].createElement(_DragSpin["default"], {
    out: displayedDragIconMessage
  }) : null), /*#__PURE__*/_react["default"].createElement(Styled.SurroundContainer, {
    isMobile: isMobile,
    className: lpClassName,
    ref: visualizerRef
  })), dragMessage && displayDragMessage ? /*#__PURE__*/_react["default"].createElement(Styled.DragMessage, null, dragMessage) : null);
};
Vizualizer.propTypes = {
  lpActive: _propTypes["default"].bool,
  isMobile: _propTypes["default"].bool,
  lpClassName: _propTypes["default"].string,
  surroundLibrary: _propTypes["default"].string,
  textureLoadedUpdatePath: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onLiquidPixelVisualizerLoadedSuccessfully: _propTypes["default"].func,
  dragMessage: _propTypes["default"].string,
  showDragIcon: _propTypes["default"].bool,
  autoRotate: _propTypes["default"].bool,
  displayDragMessage: _propTypes["default"].bool,
  visualizerChoices: _propTypes["default"].object,
  visIsReady: _propTypes["default"].bool.isRequired,
  setVisIsReady: _propTypes["default"].func.isRequired,
  activeTab: _propTypes["default"].string
};
Vizualizer.defaultProps = {
  lpActive: false,
  isMobile: false,
  lpClassName: 'surroundViewer',
  surroundLibrary: 'https://homedepot.liquifire.com/zap/dhtml/com.liquidpixels.Surround.jsr',
  textureLoadedUpdatePath: _noop["default"],
  onError: _noop["default"],
  onLiquidPixelVisualizerLoadedSuccessfully: _noop["default"],
  dragMessage: 'Drag to Spin',
  showDragIcon: true,
  autoRotate: false,
  displayDragMessage: true,
  visualizerChoices: undefined,
  activeTab: ''
};
var _default = /*#__PURE__*/(0, _react.memo)(Vizualizer);
exports["default"] = _default;
//# sourceMappingURL=index.js.map